import { render, staticRenderFns } from "./root-program.vue?vue&type=template&id=c1e242e0"
import script from "./root-program.vue?vue&type=script&lang=js"
export * from "./root-program.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports